<template>
  <v-app class="login__bg">
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col cols="12" md="5" lg="4">
          <div class="d-flex justify-center align-center animate-fadeInUp">
            <v-card flat color="transparent">
              <div class="d-flex justify-center mb-4">
                <img src="../assets/bglogo.svg" alt="janguAsk logo" width="150" class="animate-float" />
              </div>
              <v-card
                max-width="400"
                width="100%"
                class="premium-card-elevated pa-2 mx-auto"
              >
                <v-card-text>
                  <div class="mb-4">
                    <h3 class="black--text" style="font-size: 22px; font-weight: 700">
                      Welcome Back
                    </h3>
                    <p class="grey--text text--darken-1 mb-0" style="font-size: 14px">
                      Sign in to continue to janguAsk
                    </p>
                  </div>

                  <v-form @submit.prevent="logIn" ref="form" lazy-validation>
                    <v-col cols="12" class="py-1 px-0">
                      <v-text-field
                        outlined
                        dense
                        rounded
                        class="custom__field"
                        placeholder="Email address"
                        prepend-inner-icon="mdi-email-outline"
                        :rules="[rules.required, rules.email]"
                        v-model="email"
                        color="#f69227"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0 px-0">
                      <v-text-field
                        outlined
                        dense
                        rounded
                        placeholder="Password"
                        prepend-inner-icon="mdi-lock-outline"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="password"
                        color="#f69227"
                        :rules="[rules.required, rules.password]"
                        class="custom__field"
                        @click:append="showPassword = !showPassword"
                        hide-details="auto"
                      ></v-text-field>
                      <div class="d-flex justify-end">
                        <v-btn text x-small class="my-2 text-capitalize" color="#f69227">
                          Forgot password?
                        </v-btn>
                      </div>
                    </v-col>
                  </v-form>

                  <v-col cols="12" class="py-2 px-0">
                    <v-btn
                      block
                      height="48"
                      rounded
                      large
                      :loading="isLoading"
                      :disabled="isLoading"
                      color="#f69227"
                      class="white--text text-capitalize hover-scale hover-glow-orange"
                      style="font-weight: 600; font-size: 15px"
                      @click="logIn"
                    >
                      <v-icon left small>mdi-login</v-icon>
                      Sign In
                    </v-btn>
                  </v-col>

                  <div class="d-flex align-center my-3">
                    <v-divider></v-divider>
                    <span class="mx-3 grey--text" style="font-size: 12px; white-space: nowrap">or continue with</span>
                    <v-divider></v-divider>
                  </div>

                  <v-row no-gutters>
                    <v-col cols="6" class="pr-1">
                      <v-btn
                        block
                        outlined
                        rounded
                        height="44"
                        class="text-capitalize hover-scale"
                        color="#4267B2"
                        @click="socialLogin('Facebook')"
                      >
                        <v-icon left small>mdi-facebook</v-icon>
                        Facebook
                      </v-btn>
                    </v-col>
                    <v-col cols="6" class="pl-1">
                      <v-btn
                        block
                        outlined
                        rounded
                        height="44"
                        class="text-capitalize hover-scale"
                        color="#DB4437"
                        @click="socialLogin('Google')"
                      >
                        <v-icon left small>mdi-google</v-icon>
                        Google
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <p class="d-flex align-center justify-center mt-4" style="font-size: 14px; color: #666">
                Don't have an account?
                <v-btn
                  small
                  text
                  to="/signup"
                  color="#f69227"
                  class="text-capitalize ml-1"
                  style="font-weight: 600"
                >Sign Up</v-btn>
              </p>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-footer color="transparent" padless absolute>
      <v-row justify="center" no-gutters>
        <img src="../assets/logo grey.svg" width="70" alt="logo" class="mx-1" />
        <p class="rights grey--text" style="font-size: 11px">
          <span class="mx-1">&copy;</span>{{ new Date().getFullYear() }} janguAsk
        </p>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    showPassword: false,
    email: "",
    password: "",
    isLoading: false,
    rules: {
      required: (v) => !!v || "This field is required",
      counter: (v) => (v && v.length >= 5) || "Minimum length is 5 characters",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Please enter a valid email address";
      },
      password: (value) =>
        (value && value.length >= 6) || "Password must be at least 6 characters",
    },
  }),
  methods: {
    logIn() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.isLoading = true;
      // Simulate backend authentication
      setTimeout(() => {
        this.isLoading = false;
        this.$root.store.login(this.email);
        this.$root.showSnackbar(
          "Welcome back! Redirecting to dashboard...",
          "#43a047",
          "mdi-check-circle"
        );
        setTimeout(() => {
          this.$router.push("/home");
        }, 800);
      }, 1800);
    },
    socialLogin(provider) {
      this.$root.showSnackbar(
        `${provider} sign-in is not available at the moment. Please use email login.`,
        "#ef5350",
        "mdi-alert-circle"
      );
    },
  },
};
</script>

<style scoped>
.login__bg {
  background: linear-gradient(135deg, #fafbfc 0%, #f0f2f5 50%, #fef6ec 100%);
  min-height: 100vh;
}

.custom__field {
  border-radius: 25px !important;
}

.custom__field .v-input__slot {
  border-radius: 25px !important;
}
</style>
